import React from 'react'
import {Grid, Stack, Typography} from "@mui/material";
import {getCurrentLanguage} from "../../utils/Helpers";

const cities = require("../../data/cities.json")
const tree_species = require("../../data/tree_species.json")
const sky_view_factors = require("../../data/sky_view_factor.json")
const soil_types = require("../../data/soil_types.json")
const InputLayout = (props:any) =>{
    const {t,i18n} = props;
    const langKey = getCurrentLanguage(i18n);
    const input = JSON.parse(localStorage.getItem("tum_leitfaden_input") as string) as any
    const city = cities[langKey].find((city: any) => city.id === Number(input.city_id))
    const tree_specie = tree_species[langKey].find((tree_specie: any) => tree_specie.id === input.tree_species)
    const sky_view_factor = sky_view_factors[langKey].find((factor:any) => factor.id === input.svf_id)
    const soil_type = soil_types[langKey].find((soil:any) => soil.id === input.soil_type_id)

    const changeTreeSize = (tree_size:number) =>{
        switch (tree_size){
            case 10:
               return "<10"
            case 20:
                return "10-20"
            case 30:
                return "20-30"
            case 40:
                return "30-40"
            case 50:
                return "40-50"
            case 60:
                return "50-60"
            case 70:
                return "60-70"
            case 80:
                return "70-80"
            case 90:
                return "80-90"
            case 100:
                return "90>"
        }
    }


    return(
        <Grid container>
            <Grid item xs={12} style={{padding: 4, margin: 8}}>
                <Typography variant="h5" style={{fontWeight: "bold"}}>
                    {city.name}
                </Typography>
                <br/>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Stack direction="row" justifyContent="flex-start" spacing={4}>
                            <Typography variant="body1">
                                {tree_specie && tree_specie.name}
                            </Typography>
                            <Typography style={{fontStyle: 'italic', marginLeft: 4}}>
                                ({tree_specie && tree_specie.scientific_name})
                            </Typography>
                        </Stack>
                    </Grid>
                    <Grid item xs={12}>
                        <Stack direction="row" spacing={4}>
                            <Typography variant={"body1" as any}>
                                {t('info_page.tree_size.title')}{":"}
                            </Typography>
                            <Typography variant={"body1" as any}>
                                {changeTreeSize(input.tree_size)} cm
                            </Typography>
                        </Stack>
                    </Grid>
                    <Grid item xs={12}>
                        <Stack direction="row" spacing={4}>
                            <Typography variant={"body1" as any}>
                                {t('info_page.sky_view_factor.title')}:
                            </Typography>
                            <Typography variant={"body1" as any}>
                                {sky_view_factor && sky_view_factor.name}
                            </Typography>
                        </Stack>
                    </Grid>
                    <Grid item xs={12}>
                        <Stack direction="row" spacing={4}>
                            <Typography variant={"body1" as any}>
                                {t('info_page.soil_type.title')}:
                            </Typography>
                            <Typography variant={"body1" as any}>
                                {soil_type && soil_type.name}
                            </Typography>
                        </Stack>
                    </Grid>
                    <Grid item xs={12}>
                        <Stack direction="row" spacing={4}>
                            <Typography variant={"body1" as any}>
                                {t('info_page.soil_sealing.title')}:
                            </Typography>
                            <Typography variant={"body1" as any}>
                                {input && input.soil_sealing} %
                            </Typography>
                        </Stack>
                    </Grid>
                    <Grid item xs={12}>
                        <Stack direction="row" spacing={4}>
                            <Typography variant={"body1" as any}>
                                {t('info_page.period.title')}:
                            </Typography>
                            <Typography variant={"body1" as any}>
                                {input && input.period}
                            </Typography>
                        </Stack>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}
export default InputLayout
